<template>
    <div class="ui selection dropdown">
        <input type="hidden" :name="name">
        <i class="dropdown icon"></i>
        <div class="default text">{{placeholder}}</div>
        <div class="menu">
            <div v-for="option in options" class="item" :data-value="option[valueAtt]">{{option[labelAtt]}}</div>
        </div>
    </div>
</template>
<script>
  import JqHttpUtil from '../../../util/JqHttpUtil'

  export default {
    data () {
      return {
        options: [],
        rq: 0,
        loading: true
      }
    },
    /**
     * requestData:_ Es un objeto que es escuchado por este componente y actualiza las opciones cada vez que se cambia
     */
    props: ['name', 'value', 'endpoint', 'searchable', 'ddOptions', 'selectedObj', 'placeholder', 'labelAtt', 'valueAtt',
      'defaultValue', 'disabled', 'requestData', 'cache', 'clearable'],
    mounted: function () {
      jQuery(this.$el).addClass('disabled')

      if (this.searchable === true) {
        jQuery(this.$el).addClass('search')
      }

      let componentOptions = {
        onChange: (value, text, $choice) => {
          this.$emit('update:value', value)

          if (value === '') {
            this.$emit('update:selectedObj', {})
          } else {
            for (let i = 0; i < this.options.length; i++) {
              let obj = this.options[i]
              /* Si el valueAtt es un entero */
              if (typeof obj[this.valueAtt] === 'number' && (obj[this.valueAtt] % 1) === 0) {
                // Como es un entero se convierte en entero el valor
                let intValue = parseInt(value)
                if (obj[this.valueAtt] === intValue) {
                  this.$emit('update:selectedObj', obj)
                  break
                }
              } else {
                /* Se busca normal */
                if (obj[this.valueAtt] === value) {
                  this.$emit('update:selectedObj', obj)
                  break
                }
              }
            }
          }
        }
      }
      if (this.clearable === true) {
        componentOptions.clearable = true
      }

      Object.assign(componentOptions, this.ddOptions)

      this.http = new JqHttpUtil(this.endpoint + '/lov')

      this.dropdown = jQuery(this.$el).dropdown(componentOptions)
      this.dropdown.find('input.search').attr('autocomplete', 'new-password')
      this.loadData()
    },
    watch: {
      selectedObj: function (val) {
        this.evaluateSelectedObj(val)
      },
      loading: function () {
        if (this.loading || (typeof this.disabled !== 'undefined' && this.disabled)) {
          jQuery(this.$el).addClass('disabled')
        } else {
          jQuery(this.$el).removeClass('disabled')
        }
      },
      disabled: function () {
        if (this.loafing || (typeof this.disabled !== 'undefined' && this.disabled)) {
          jQuery(this.$el).addClass('disabled')
        } else {
          jQuery(this.$el).removeClass('disabled')
        }
      },
      requestData: function () {
        this.loadData()
      }
    },
    methods: {
      processSelectedObj: function (val) {
        if (val === null || typeof val === 'undefined' || typeof val[this.valueAtt] === 'undefined' || val[this.valueAtt] === null || val[this.valueAtt] === '') {
          this.dropdown.dropdown('clear')
          this.dropdown.dropdown('refresh')
        } else {
          this.dropdown.dropdown('set selected', val[this.valueAtt])
          this.dropdown.dropdown('set value', val[this.valueAtt])
          this.dropdown.dropdown('refresh')
        }
      },
      evaluateSelectedObj: function (val) {
        /* Es posible que se ejecute el set antes de que lleguen los valores de la lista por lo que debe sincronizar */
        if (typeof this.dropdown === 'undefined') {
          let actual = ++this.rq
          let self = this
          setTimeout(function () {
            if (actual === self.rq) {
              self.evaluateSelectedObj(val)
            }
          }, 100)
          return
        }
        this.processSelectedObj(val)
      },
      refresh: function () {
        this.dropdown.dropdown('refresh')
      },
      clear: function () {
        this.dropdown.dropdown('clear')
      },
      loadData: function () {
        this.loading = true
        this.http.get(this.requestData, {
          cache: typeof this.cache === 'undefined' ? true : this.cache
        }, (response) => {
          let currentValue = this.value
          this.clear()
          this.options = response

          if (this.options - length === 0) {
            let tmp = {}
            tmp[this.labelAtt] = 'Sin resultados'
            tmp[this.valueAtt] = ''
            this.options.push(tmp)
          }

          this.refresh()

          if (typeof currentValue !== 'undefined') {
            setTimeout(() => {
              this.dropdown.dropdown('set value', currentValue)
              this.dropdown.dropdown('set selected', currentValue)
            }, 100)
          }else if (typeof this.defaultValue !== 'undefined') {
            setTimeout(() => {
              this.dropdown.dropdown('set value', this.defaultValue)
              this.dropdown.dropdown('set selected', this.defaultValue)
            }, 100)
          }
          this.loading = false
        }, (response) => {
          let tmp = {}
          this.options.splice(0, this.options.length)
          tmp[this.labelAtt] = 'Error interno'
          tmp[this.valueAtt] = 'Error'
          this.options.push(tmp)
          this.refresh()
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/dropdown/dropdown.vue